import { Component, OnInit } from '@angular/core';
import { CourtReservation } from '../../model/court-reservation';
import { ActivatedRoute } from '@angular/router';
import { ConfirmMatchComponent } from '../confirm-match/confirm-match.component';
import { CourtReservationService } from '../../services/court-reservation.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-your-match',
  standalone: true,
  imports: [ConfirmMatchComponent],
  templateUrl: './your-match.component.html',
  styleUrl: './your-match.component.css'
})
export class YourMatchComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private reservationService: CourtReservationService,
    private authService: AuthenticationService
  ) {}

  courtReservation!: CourtReservation;

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (!isNaN(id)) {
      const start = new Date(2000, 0, 1);
      const end = new Date(2100, 0, 1);
      const userId = this.authService.currentUserValue?.id;
      if (!userId) return;
      this.reservationService
        .getCourtReservationsForUser(userId, start, end)
        .subscribe((reservations: any[]) => {
          const match = reservations.find((r: any) => r.id === id);
          if (match) {
            const startDt = new Date(match.reservation_start_time);
            const players = (match.courtReservationPlayer || []).sort(
              (a: any, b: any) => a.position - b.position
            );
            this.courtReservation = {
              ...match,
              date: startDt.toISOString().split('T')[0],
              time: startDt.getHours(),
              player_ids: players.map((p: any) => p.player_id),
              courtReservationPlayer: players,
            } as CourtReservation;
          }
        });
    }
  }
}
